const LABELS = {
  instagram: 'Instagram', tiktok: 'TikTok', facebook: 'Facebook', youtube: 'YouTube',
  linkedin: 'LinkedIn', twitter: 'X', x: 'X', threads: 'Threads', pinterest: 'Pinterest', bluesky: 'Bluesky',
};

export const getPostDestinations = (post) => {
  const saved = new Map((post.account_snapshots || []).filter(a => a.id).map(a => [a.id, a]));
  const rows = new Map();
  const add = (id, channel = {}) => {
    const account = saved.get(id) || {};
    const platform = (channel.platform || account.platform || '').toLowerCase();
    const username = String(account.username || channel.username || '').trim().replace(/^@+/, '');
    const name = String(account.display_name || channel.account_name || '').trim();
    const identity = username ? (/^[\p{L}\p{M}\p{N}_.-]+$/u.test(username) ? `@${username}` : username) : name || 'Handle not recorded';
    const key = id || channel.id || `${platform}-${rows.size}`;
    if (!rows.has(key)) rows.set(key, { key, platform, label: LABELS[platform] || platform || 'Account', identity });
  };
  (post.chat33_posts || []).forEach(channel => add(channel.account_id, channel));
  const ids = post.account_ids?.length ? post.account_ids : [...saved.keys()];
  ids.forEach(id => { if (!rows.has(id)) add(id); });
  return [...rows.values()];
};